// extracted by mini-css-extract-plugin
module.exports = {"figcaption":"styles_figcaption__1QPXO","img":"styles_img__AVoat"};